import { NavigateBeforeSharp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";

type TOwnProps = {
  onClick: () => void;
};

const PrevButton = (props: TOwnProps) => {
  const { onClick } = props;
  return (
    <IconButton onClick={onClick} size="large">
      <NavigateBeforeSharp fontSize="large" />
    </IconButton>
  );
};

export default PrevButton;
